export default __webpack_public_path__ + "static/media/discord.0847c0e7.svg";